import styled from 'styled-components';
import { TableHead, Paper, CircularProgress, FormControl, IconButton, Icon } from '@material-ui/core';

export const RowTable = styled.div`
  display:  flex;
  flex-wrap: wrap;
  & > :last-child {
    display: flex;
    align-items: center;
    flex: 100%
  }
`

export const RowItem = styled.div`
  margin-right: 5px;
`

export const CustomSpan = styled.div`
  margin-bottom: 14px;
`

export const CustomFormControl = styled(FormControl)`
  && {
    min-width: 150px;
  }
`

export const CustomIconButton = styled(IconButton)`
  && {
    margin-left: -10px;
  }
`

export const CustomIcon = styled(Icon)`
  && {
    color: ${props => props.cor ? 'var(--dark-gray)' : 'var(--light-gray)'};
    font-size: medium;
  }
`

export const PaperTable = styled(Paper)`
  flex-wrap: wrap;
  margin-top: 20px;
`

export const TableHeader = styled(TableHead)`
  background-color: var(--grey);
`

export const Loading = styled(CircularProgress)`
 && {
  color: var(--primary);
 }
`
